setInterval(() => {
  document.querySelectorAll(".smart-tabs-accordion-plus").forEach(el => {
    el.innerHTML = `<svg id="fi_2985150" style="height: 18px; width: 18px;" enable-background="new 0 0 128 128" height="512" viewBox="0 0 128 128" width="512" xmlns="http://www.w3.org/1800/svg"><path id="Down_Arrow_3_" d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"></path></svg>`;
  });
  document.querySelectorAll(".smart-tabs-accordion-minus").forEach(el => {
    el.innerHTML = `<svg fill="none" style="height: 18px; width: 18px" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_9497436"><path clip-rule="evenodd" d="m11.4697 6.46967c.2929-.29289.7677-.29289 1.0606 0l8 8.00003c.2929.2929.2929.7677 0 1.0606s-.7677.2929-1.0606 0l-7.4697-7.46964-7.46967 7.46964c-.29289.2929-.76777.2929-1.06066 0s-.29289-.7677 0-1.0606z" fill="rgb(0,0,0)" fill-rule="evenodd"></path></svg>`;
  });
}, 500);
/* Sticky Add to Bag: reuses the existing Shopify product form so theme cart
   behaviour and future cart-drawer integrations remain intact. */
(function () {
  /* Keep the product quantity controls working even when a page script is
     deferred or unavailable in a theme preview. */
  document.addEventListener('click', function (event) {
    var control = event.target.closest ? event.target.closest('.quantity-wrapper [data-quantity]') : null;
    if (!control) return;

    var input = control.closest('.quantity-wrapper').querySelector('[name="quantity"]');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();

    var step = parseInt(input.getAttribute('step') || '1', 10);
    var current = parseInt(input.value || '1', 10);
    var next = control.getAttribute('data-quantity') === 'up' ? current + step : current - step;
    input.value = Math.max(1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  function initStickyAddToBag(root) {
    var formId = root.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : null;
    var originalButton = form ? form.querySelector('.button--add_to_cart') : null;
    var stickyButton = root.querySelector('[data-sticky-submit]');

    if (!form || !originalButton || !stickyButton) return;

    function syncButtonState() {
      stickyButton.disabled = originalButton.disabled;
      if (originalButton.getAttribute('data-add-to-cart-text')) {
        stickyButton.textContent = originalButton.getAttribute('data-add-to-cart-text');
      }
    }

    function setVisibility(isVisible) {
      root.hidden = !isVisible;
      root.classList.toggle('is-visible', isVisible);
    }

    syncButtonState();

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        setVisibility(!entries[0].isIntersecting);
      }, { threshold: 0.01 });
      observer.observe(originalButton);
    } else {
      setVisibility(false);
    }

    form.addEventListener('change', syncButtonState);
    new MutationObserver(syncButtonState).observe(originalButton, {
      attributes: true,
      attributeFilter: ['disabled', 'data-add-to-cart-text']
    });
  }

  function initAllStickyAddToBag() {
    document.querySelectorAll('[data-sticky-add-to-bag]').forEach(initStickyAddToBag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStickyAddToBag);
  } else {
    initAllStickyAddToBag();
  }
})();
